var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.renderChart)?_c('vue-apex-charts',{attrs:{"height":_vm.height,"width":"300px","type":"pie","options":_vm.options,"series":_vm.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }